import { render, staticRenderFns } from "./classic-html-editor.vue?vue&type=template&id=e59723fa&"
import script from "./classic-html-editor.vue?vue&type=script&lang=js&"
export * from "./classic-html-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports